<template>
  <b-card no-body>
    <PageLoading v-if="isLoading" />
    <b-card-body
      v-else
      id="customers-card-body"
      class="d-flex flex-column align-items-center justify-content-center"
    >
      <div class="d-flex w-100 mb-1 justify-content-center">
        <div class="col-sm-2 pr-2">
          <label class="mb-0">{{ t('Account Number') }}</label>
        </div>
        <div class="col-sm-4">
          <b-form-input v-model="providerDetails.account_identification" readonly />
        </div>
      </div>

      <div class="d-flex w-100 mb-1 justify-content-center">
        <div class="col-sm-2 pr-2">
          <label class="mb-0">{{ t('Currency Code') }}</label>
        </div>
        <div class="col-sm-4">
          <validation-provider #default="{ errors }" :name="t('Currency Code')" rules="required">
            <v-select
              id="currency_code"
              v-model="providerDetails.currency"
              :options="currencies"
              :placeholder="t('Make a Choice')"
              label="text"
              :tabindex="3"
            >
              <span slot="no-options">{{ t('No records found') }}</span>
            </v-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </div>
      </div>

      <div class="d-flex w-100 mb-1 justify-content-center">
        <div class="col-sm-2 pr-2">
          <label class="mb-0">{{ $t('Cargo Acceptance Duration (Days)') }}</label>
        </div>
        <div class="col-sm-4">
          <b-form-input type="number" v-model="providerDetails.expiration_days" min="1" />
        </div>
      </div>

      <div class="border rounded mb-2 p-2 d-flex justify-content-center align-items-center">
        <feather-icon icon="InfoIcon" class="mr-1" size="16" />
        <small
          v-html="
            $t('Cargo Acceptance Duration Info', {
              days:
                typeof providerDetails.expiration_days === 'number'
                  ? providerDetails.expiration_days
                  : 'X'
            })
          "
        ></small>
      </div>

      <b-button variant="primary" @click="submit">{{ t('Save') }}</b-button>

      <region-pricing-table-view v-if="rows" :data="rows" class="mt-3" />
    </b-card-body>
  </b-card>
</template>

<script>
import { BButton, BCard, BCardBody, BFormInput } from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { helper } from '@core/mixins/helper.js';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import useService from '@/auth/service/useService';
import vSelect from 'vue-select';
import PageLoading from '@core/components/PageLoading.vue';
import { ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import RegionPricingTableView from './RegionPricingTableView.vue';

export default {
  components: {
    PageLoading,
    ValidationProvider,
    BButton,
    BCard,
    BCardBody,
    BFormInput,
    vSelect,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    RegionPricingTableView
  },

  mixins: [helper],
  computed: {
    ...mapGetters({
      countries: 'app/countries',
      currencies: 'app/currencies',
      providerDetails: 'app/providerDetails'
    })
  },
  data() {
    return {
      isLoading: false,
      rows: null,

      currencyOptions: []
    };
  },

  async created() {
    if (
      Object.keys(this.providerDetails).length < 1 ||
      (Object.keys(this.providerDetails).length > 0 &&
        parseInt(this.providerDetails.id) !== parseInt(this.$route.params.id))
    ) {
      this.isLoading = true;
      await this.$store.dispatch('app/getProviderDetails', this.$route.params.id);
      this.isLoading = false;
    }

    await this.$store.dispatch('app/getCurrencies');

    if (this.providerDetails && this.providerDetails.currency) {
      const currencyCode =
        typeof this.providerDetails.currency === 'string'
          ? this.providerDetails.currency
          : this.providerDetails.currency.code;
      const currencyObj = this.currencies.find(c => c.code === currencyCode);
      if (currencyObj) {
        this.providerDetails.currency = currencyObj;
      }
    }
  },

  methods: {
    submit() {
      this.submitting = true;

      const requestData = {
        pricing_type: 'kg_or_desi_min_max',
        currency: this.providerDetails.currency.code,
        expiration_days: this.providerDetails.expiration_days,
        status: 1
      };

      useService
        .editProvider(this.$route.params.id, requestData)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
